<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          btnTitle="Add New"
          :showBtn="false"
          :showAddNew="true"
          @onClickAddNewButton="openModal"
      />
    </div>

    <div
        v-for="master in tableItems"
        :key="master.id"
        class="card px-2 mb-1" style="min-height: 200px"
    >
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <strong>{{ master.project_name }}</strong>
          <small>
            ({{ master.start_date }} → {{ master.end_date }})
          </small>
        </div>

        <button v-if="false"
            class="btn btn-sm btn-outline-primary"
        >
          Edit
        </button>
      </div>

      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table mb-0 table-bordered">
            <thead class="table-light">
            <tr>
              <th>Payment Type</th>
              <th>Schedule Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="general in master.generals"
                :key="general.id"
            >
              <td>{{ general.title }}</td>
              <td>{{ general.date }}</td>
              <td>{{ general.amount }}</td>
              <td>
            <span
                :class="[
                'badge text-capitalize',
                general.status === 'due'
                  ? 'bg-warning'
                  : 'bg-success'
              ]"
            >
              {{ general.status }}
            </span>
              </td>
              <td>
                <button v-if="general.status === 'due'" @click="openMoneyReceiptModal(general)" class="btn btn-sm btn-outline-primary">
                  Pay Now
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>    <div class="mb-2"></div>
    <Loader v-if="loading"/>

    <InstallmentPlanSetupModal
        v-if="isModalOpen"
        :contact="selectedContact"
        @close="closeModal"
        @getData="getBillPaymentData"
    />

    <MoneyReceiptModal
        v-if="isMoneyReceiptModalOpen"
        :contact="selectedContact"
        :generalData="generalData"
        @close="closeMoneyReceiptModal"
        @getData="getBillPaymentData"
    />
  </div>
</template>

<script setup>
import TitleButton from "@/components/atom/TitleButton.vue";
import {onMounted, ref, watch} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import InstallmentPlanSetupModal from "@/views/page/company/procurement/shareholder-register/bill-payment/InstallmentPlanSetupModal.vue";
import MoneyReceiptModal from "@/views/page/company/procurement/shareholder-register/bill-payment/MoneyReceiptModal.vue";
import handleProjects from "@/services/modules/procurement/project";
import {useRoute} from "vue-router";

const loading = ref(false)
const isModalOpen = ref(false)
const isMoneyReceiptModalOpen = ref(false)
const selectedContact = ref(null)
const generalData = ref({})
const tableItems = ref([])
const $route = useRoute();

const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  }
})

const { getProjectInstallmentSetupData } = handleProjects();

const openModal = () => {
    isModalOpen.value = true;
    selectedContact.value = props.contactInfo
}

const openMoneyReceiptModal = (item) => {
  isMoneyReceiptModalOpen.value = true;
  selectedContact.value = props.contactInfo
  generalData.value = item
}

const closeModal = () => {
  isModalOpen.value = false
}

const closeMoneyReceiptModal = () => {
  isMoneyReceiptModalOpen.value = false
}

watch(
    () => props.contactInfo,
    (newVal) => {
      if (newVal && newVal.id) {
        getBillPaymentData();
      }
    },
    { immediate: true }
);

const getQuery = () => {
  let query = '?company_id=' + $route.params.companyId
   query += '&contact_profile_id=' + props.contactInfo.id
  return query
};

async function getBillPaymentData() {
  let query = getQuery();
  try {
    const res = await getProjectInstallmentSetupData(query);
    if (!res.status) {
      tableItems.value = [];
    }
    tableItems.value = res.data;
  } catch (err) {

  }
}

</script>
